import React from 'react';
import { Upload, FileText } from 'lucide-react';
import Message from './ErrorMessage';

function FileUpload({ onFile, fileName, isProcessing, message, messageType, chartType, uploadKey }) {
  return (
    <div className="space-y-6">
      {/* Upload Area */}
      <div className="relative border-2 border-dashed border-gray-300 rounded-xl p-6 bg-gray-50 hover:bg-blue-50 hover:border-blue-300 transition-all duration-200 group">
        <div className="text-center">
          <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-200">
            <Upload className="w-6 h-6 text-white" />
          </div>
          
          <h3 className="text-lg font-semibold text-gray-800 mb-2">
            Faça upload do seu arquivo
          </h3>
          
          <p className="text-gray-600 mb-4 text-sm">
            Arraste e solte seu arquivo aqui ou clique para selecionar
          </p>
          
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="flex items-center gap-2 px-3 py-1 bg-white rounded-full border border-gray-200">
              <FileText className="w-4 h-4 text-gray-500" />
              <span className="text-xs font-medium text-gray-600">CSV</span>
            </div>
            <div className="flex items-center gap-2 px-3 py-1 bg-white rounded-full border border-gray-200">
              <FileText className="w-4 h-4 text-gray-500" />
              <span className="text-xs font-medium text-gray-600">XLSX</span>
            </div>
          </div>
          
          <input
            key={uploadKey}
            type="file"
            accept=".csv, .xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            className="hidden"
            id="file-upload"
            onChange={onFile}
            disabled={isProcessing}
          />
          
          <label 
            htmlFor="file-upload" 
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg font-semibold hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105 cursor-pointer"
          >
            {isProcessing ? (
              <>
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                Processando...
              </>
            ) : (
              <>
                <Upload className="w-4 h-4" />
                Selecionar arquivo
              </>
            )}
          </label>
          
          <div className="text-xs text-gray-500 text-center mt-2">
            Tamanho suportado: <span className="font-mono">2MB</span>
          </div>
          
          {fileName && (
            <div className="mt-4 p-3 bg-green-50 border border-green-200 rounded-lg">
              <div className="flex items-center justify-center gap-2">
                <FileText className="w-4 h-4 text-green-600" />
                <span className="text-sm font-medium text-green-800">
                  Arquivo: {fileName}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
      
      <Message message={message} type={messageType} />
    </div>
  );
}

export default FileUpload;
